"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _avlComponents = require("@availabs/avl-components");

var _Container = _interopRequireDefault(require("./components/Container"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AmsEmailPreferences = function AmsEmailPreferences(_ref) {
  var newPreferences = _ref.newPreferences,
      setNewPreferences = _ref.setNewPreferences,
      updateDisabled = _ref.updateDisabled,
      updateEmailPreferences = _ref.updateEmailPreferences,
      props = _objectWithoutProperties(_ref, ["newPreferences", "setNewPreferences", "updateDisabled", "updateEmailPreferences"]);

  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    Title: "Email Preferences"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-1 gap-y-3"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "block font-bold"
  }, "Send Messages to Email"), /*#__PURE__*/_react["default"].createElement(_avlComponents.BooleanInput, {
    value: newPreferences.receiveEmail,
    onChange: setNewPreferences
  })), /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    buttonTheme: "buttonLargePrimaryBlock",
    onClick: updateEmailPreferences,
    disabled: updateDisabled
  }, "update preferences")));
};

var emailPreferences = {
  type: AmsEmailPreferences,
  wrappers: ["ams-email-preferences"]
};
var _default = emailPreferences;
exports["default"] = _default;